// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EntlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel {
    'data': EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel | null;
    'success': boolean;
    'messages': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EntlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EntlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.attributeTypeMap;
    }
}
